import { AssessmentQuestionSubType } from '@transcend-io/privacy-types';

import {
  DynamicAssessmentQuestionSubType,
  StaticAssessmentQuestionSubType,
} from '../../schema/enums';

/**
 * Whether the sub-type of an assessment question requires a dynamic answer
 * fetched from the data inventory.
 *
 * @param subType - the sub-type of the assessment question
 * @returns whether the sub-type is dynamic
 */
export const isDynamicAssessmentQuestionSubType = (
  subType?: AssessmentQuestionSubType,
): subType is DynamicAssessmentQuestionSubType =>
  !!subType && Object.keys(DynamicAssessmentQuestionSubType).includes(subType);

/**
 * Whether the sub-type of an assessment question requires a static answer
 * that does not need to be fetched from the data inventory.
 *
 * @param subType - the sub-type of the assessment question
 * @returns whether the sub-type is dynamic
 */
export const isStaticAssessmentQuestionSubType = (
  subType?: AssessmentQuestionSubType,
): subType is StaticAssessmentQuestionSubType =>
  !!subType && Object.keys(StaticAssessmentQuestionSubType).includes(subType);
